import Popover from "@mui/material/Popover";
import React, {useState} from "react";
import IconButton from "@mui/material/IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import makeStyles from "@mui/styles/makeStyles";
import {Divider, FormLabel} from "@mui/material";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        width: 400,
        padding: 10,
        borderRadius: 10,
        fontSize: 13,
        overflow: 'hidden',
        backgroundColor: ({ agyleRefresh }) => !agyleRefresh ? null : theme.palette.background.paperDarker,
    },
    label: {
        color: theme.palette.mode === "light" ? "#000" : "#FFF",
        fontWeight: "bold",
        margin: "10px 0",
    },
}));

const SearchHint = ({ agyleRefresh }) => {
    const classes = useStyles({ agyleRefresh });
    const {t} = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null);
    const openHelp = Boolean(anchorEl);

    const handleOpenHelpText = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseHelpText = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton disableRipple onMouseEnter={handleOpenHelpText} onMouseLeave={handleCloseHelpText}>
                <HelpOutlineIcon/>
            </IconButton>


            <Popover
                open={openHelp}
                anchorEl={anchorEl}
                sx={{
                    pointerEvents: "none",
                    borderRadius: 10,
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handleCloseHelpText}
                disableRestoreFocus
                className={classes.popoverRoot}
                PaperProps={agyleRefresh ? (
                    { style: { borderRadius: 12 } }
                ) : {}}
            >
                <div className={classes.root}>
                    <FormLabel className={classes.label}>
                        {t("Help")}
                    </FormLabel>

                    <Divider sx={{m: 1}}/>

                    <div>
                        {t("You can search for a patient using any combination of their demographic or GP details. This includes")}
                    </div>

                    <ul>
                        <li>{t("Forename")}</li>
                        <li>{t("Surname")}</li>
                        <li>{t("Surname with DOB")}</li>
                        <li>{t("NHS No.")}</li>
                        <li>{t("Hospital No.")}</li>
                    </ul>

                    <div>
                        {t("Searching on the date of birth must be in the UK standard format: dd/mm/yyyy.")}{" "}
                        {t("The day and month can be 1 or 2 digits and the year must be 4 digits.")}
                    </div>

                    <div style={{marginTop: 10}}>
                        {t("You can also use similar sounding words to find a patient name e.g. washington --> Washincton")}
                    </div>
                </div>
            </Popover>
        </>
    );
};

export default SearchHint;